import React from 'react';

import './productCard.css';

const ProductCard = (props) => {
    const { imgUrl, title, price } = props.item;

    return (
        <div className="food__item">
            <div className="food__img w-100">
                <img src={imgUrl} alt={title} className="w-100" />
            </div>

            <div className="food__content">
                <div className="rating text-center">
                    <span>
                        <i className="ri-star-fill"></i>
                    </span>
                    <span>
                        <i className="ri-star-fill"></i>
                    </span>
                    <span>
                        <i className="ri-star-fill"></i>
                    </span>
                    <span>
                        <i className="ri-star-fill"></i>
                    </span>
                    <span>
                        <i className="ri-star-fill"></i>
                    </span>
                </div>

                <h5>{title}</h5>

                <div className="d-flex align-items-center justify-content-between ">
                    <span className="price">
                        Price: <span>${price}</span>
                    </span>

                    <span className="addToCardIcon">
                        <i className="ri-shopping-cart-line"></i>
                    </span>
                </div>
            </div>
        </div>
    );
};

export default ProductCard;
